export const PROCESS_TYPE = {
  QMA: "qma",
  COMPS: "comps",
  ADD_PROPERTY: "addProperty",
  ADD_COMP: "addComp",
  EXIT_STRATEGY: "exitStrategy",
  SOW_AGENT: "sowAgent",
  PROPERTY_DEACTIVATE: "propertyDeactivate",
};

export const PROCESS_STATUS = {
  IDLE: "idle",
  INVOKING: "invoking",
  PROCESSING: "processing",
  DONE: "done",
  ERROR: "error",
};

export const PROCESS_SCOPE = {
  PROPERTY: "property",
  GLOBAL: "global",
};

/** Types that start and are read without a propertyId (global ProcessTrackerStore key). */
export const GLOBAL_PROCESS_TYPES = new Set([PROCESS_TYPE.SOW_AGENT, PROCESS_TYPE.ADD_PROPERTY]);

/**
 * @param {string} type
 * @returns {boolean}
 */
export function isGlobalProcessType(type) {
  return GLOBAL_PROCESS_TYPES.has(type);
}

export const DEFAULT_PROCESS_TIMEOUT_MS = 5 * 60 * 1000;

/** SOW agent report generation can exceed the short-process cap; keep separate from Zillow scrapes. */
export const SOW_PROCESS_TIMEOUT_MS = DEFAULT_PROCESS_TIMEOUT_MS;

/**
 * Zillow (and any other “short” flows) use this cap so hung scrapes fail faster than QMA/comps.
 * Product/ops assumption: Zillow correlation usually completes well under two minutes; if latency
 * grows, revisit this value and add telemetry on timeout frequency before widening the window.
 */
export const SHORT_PROCESS_TIMEOUT_MS = 2 * 60 * 1000;

/** Property deactivation cascade subscription cap (matches removeProperty handler timeout). */
export const PROPERTY_DEACTIVATE_TIMEOUT_MS = 120_000;
